/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Agents_P_Mcp_DescInputs */

const en_cad_agents_p_mcp_desc = /** @type {(inputs: Cad_Agents_P_Mcp_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run cadcraft-cli mcp headless, or bridge it to the running app so Claude and other MCP clients can draw while you watch.`)
};

/**
* | output |
* | --- |
* | "Run cadcraft-cli mcp headless, or bridge it to the running app so Claude and other MCP clients can draw while you watch." |
*
* @param {Cad_Agents_P_Mcp_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_agents_p_mcp_desc = /** @type {((inputs?: Cad_Agents_P_Mcp_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Agents_P_Mcp_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_agents_p_mcp_desc(inputs)
});
export { cad_agents_p_mcp_desc as "cad.agents.p_mcp_desc" }